module.exports = __webpack_public_path__ + "static/media/Resurs 300.875a244b.png";